import React from 'react';
import { Buffer } from 'buffer';
import _ from 'lodash';

import UDPServerNOCPresentation from './UDPServerNOCPresentation';
import {
    listAllConnectedDevices,
    getDeviceMessages,
    getMessages,
} from '../../services/TCPServerAPIClient';

class UDPServerNOCContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            allMessages: [],
        }
    }

    async getDevicesMessages(connectedDevices) {
        let devicesMessages = [];

        for (let connectedDevice of connectedDevices) {
            try {
                const { data: messages } = await getDeviceMessages(connectedDevice.id);

                devicesMessages = devicesMessages.concat(messages.map(message => ({
                    source: connectedDevice.id,
                    ...message
                })));
            }
            catch (error) {
                console.error(`Error fetching device messages! ${error}`);
            }
        }

        return devicesMessages;
    }

    pollAllDevicesMessages = async () => {
        const { data: connectedDevices } = await listAllConnectedDevices();
        const connectedDeviceIdsChunks = _.chunk(connectedDevices.map(connectedDevice => connectedDevice.id), 50);

        const allMessages = [];
        for(const connectedDeviceIds of connectedDeviceIdsChunks)         {
            const chunkedMessages = connectedDeviceIds.length > 0 && (await getMessages(connectedDeviceIds))?.data?.map(message => ({
                ...message,
                timestamp: new Date(message.timestamp),
                data: Buffer.from(message.data, 'base64')
                    .toString('hex')
                    .toUpperCase(),
            }));

            allMessages.push(...chunkedMessages);
        }

        this.setState({
            allMessages: allMessages,
        });
    }

    componentDidMount() {
        this.pollAllDevicesMessages();
        this.pollAllDevicesMessagesInterval = setInterval(this.pollAllDevicesMessages, 10000);
    }

    componentWillUnmount() {
        if (this.pollAllDevicesMessagesInterval) {
            clearInterval(this.pollAllDevicesMessagesInterval);
        }
    }

    render() {
        const allMessages = this.state.allMessages;

        return <UDPServerNOCPresentation
            allMessages={allMessages}
        />;
    }
}

export default UDPServerNOCContainer;